import { MAX_WIDTH } from 'constants/maxWidth'
import React from 'react'
import { StyleSheet } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

import { Box } from 'widgets/Box'

import { useTheme } from 'contexts/ThemeContext'

import { CustomTabBarIcon } from '../CustomTabBarIcon'

export const CustomTabBar = (props: any) => {
  const insets = useSafeAreaInsets()
  const theme = useTheme()
  const { state, descriptors, navigation } = props

  const styles = StyleSheet.create({
    container: {
      paddingBottom: insets.bottom > 0 ? insets.bottom : theme.spacing.sm,
      paddingTop: theme.spacing.xs,
    },
  })

  return (
    <Box
      shadow='sm'
      justifyContent='center'
      align='center'
      backgroundColor='white'
      style={styles.container}
    >
      <Box flexDirection='row' width='100%' maxWidth={MAX_WIDTH}>
        <CustomTabBarIcon
          key={state.routes[0].name}
          descriptors={descriptors}
          navigation={navigation}
          state={state}
          route={state.routes[0]}
          index={0}
        />

        <CustomTabBarIcon
          key={state.routes[1].name}
          descriptors={descriptors}
          navigation={navigation}
          state={state}
          route={state.routes[1]}
          index={1}
        />

        <CustomTabBarIcon
          key={state.routes[2].name}
          descriptors={descriptors}
          navigation={navigation}
          state={state}
          route={state.routes[2]}
          index={2}
        />
      </Box>
    </Box>
  )
}
